export default () => {
  document.cookie.split(';').forEach((c) => {
    const eqPos = c.indexOf('=')
    const name = eqPos > -1 ? c.substr(0, eqPos) : c
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=shopfully.cloud;path=/`
  })
  window.location.reload()
}
